// extracted by mini-css-extract-plugin
export default {"info":"web-sub_info__2nht9","title":"web-sub_title__KJij7","link":"web-sub_link__6dGxE"};